'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _chooseProviderActions = require('../chooseProviderActions');

var helpActions = _interopRequireWildcard(_chooseProviderActions);

var _Loader = require('wix-style-react/dist/src/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _Modal = require('wix-style-react/dist/src/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _changeProviderHelp = require('./changeProviderHelp.scss');

var _changeProviderHelp2 = _interopRequireDefault(_changeProviderHelp);

var _ChooseProviderCloseButton = require('./ChooseProviderCloseButton');

var _ChooseProviderCloseButton2 = _interopRequireDefault(_ChooseProviderCloseButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Help = function (_Component) {
  (0, _inherits3.default)(Help, _Component);

  function Help() {
    (0, _classCallCheck3.default)(this, Help);
    return (0, _possibleConstructorReturn3.default)(this, (Help.__proto__ || (0, _getPrototypeOf2.default)(Help)).apply(this, arguments));
  }

  (0, _createClass3.default)(Help, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          helpData = _props.helpData,
          closeHelp = _props.closeHelp;
      var showHelp = helpData.showHelp,
          helpUrl = helpData.helpUrl;


      return _react2.default.createElement(
        _Modal2.default,
        {
          scrollableContent: false,
          scrollable: false,
          isOpen: showHelp,
          contentLabel: ''
        },
        _react2.default.createElement(
          'div',
          { className: _changeProviderHelp2.default.container },
          _react2.default.createElement(
            'div',
            { className: _changeProviderHelp2.default.loader },
            _react2.default.createElement(_Loader2.default, { size: 'large' })
          ),
          _react2.default.createElement('iframe', { src: helpUrl }),
          _react2.default.createElement(
            'div',
            { className: _changeProviderHelp2.default.closeButton },
            _react2.default.createElement(_ChooseProviderCloseButton2.default, { onClick: function onClick() {
                return closeHelp();
              } })
          )
        )
      );
    }
  }]);
  return Help;
}(_react.Component);

function mapStateToProps(state) {
  return { helpData: state.helpData };
}

Help.propTypes = {
  helpData: _propTypes2.default.any,
  closeHelp: _propTypes2.default.any
};

var ConnectedHelpApp = (0, _reactRedux.connect)(mapStateToProps, helpActions)(Help);

exports.default = ConnectedHelpApp;